// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3LGdw","choiceBoxes":"toolbarselects_choiceBoxes__F57wO","simpleField":"toolbarselects_simpleField__3fo2X"};